var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOracle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA1B22",
    d: "M107.936 129.682h16.512l-8.73-13.746-16.025 24.853H92.4l19.491-29.854c.847-1.206 2.26-1.935 3.827-1.935 1.514 0 2.927.704 3.749 1.885l19.568 29.904h-7.293l-3.441-5.553h-16.717l-3.647-5.554h-.001Zm75.756 5.553v-25.934h-6.189v28.473c0 .779.308 1.533.898 2.111a3.199 3.199 0 0 0 2.26.904h28.222l3.647-5.553h-28.839l.001-.001Zm-102.386-4.649c6.01 0 10.889-4.749 10.889-10.63 0-5.88-4.88-10.655-10.889-10.655H54.232v31.489h6.187v-25.934h20.477c2.876 0 5.187 2.287 5.187 5.101s-2.31 5.101-5.187 5.101l-17.447-.025 18.474 15.757h8.988l-12.429-10.203h2.825v-.001ZM16.15 140.789C7.267 140.79.059 133.753.059 125.058s7.208-15.756 16.09-15.756h18.703c8.885 0 16.088 7.061 16.088 15.756s-7.203 15.731-16.088 15.731H16.15Zm18.287-5.553c5.754 0 10.415-4.549 10.415-10.178 0-5.629-4.66-10.202-10.415-10.202H16.564c-5.753 0-10.416 4.573-10.416 10.202s4.663 10.178 10.415 10.178h17.873Zm117.515 5.553c-8.885 0-16.102-7.036-16.102-15.731s7.217-15.756 16.102-15.756h22.213l-3.621 5.554h-18.181c-5.753 0-10.426 4.573-10.426 10.202s4.673 10.178 10.426 10.178h22.315l-3.647 5.553h-19.079Zm75.678-5.553c-4.751 0-8.783-3.116-10.015-7.414h26.45l3.646-5.553h-30.096c1.232-4.273 5.264-7.413 10.015-7.413h18.156l3.671-5.555h-22.238c-8.885 0-16.101 7.061-16.101 15.756 0 8.696 7.216 15.732 16.101 15.732h19.08l3.646-5.553H227.63Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 109h250v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOracle);
export default __webpack_public_path__ + "static/media/Oracle.e523ebd4deb12745a80ef154b3ab0a3d.svg";
export { ForwardRef as ReactComponent };